import type { PostalPlace } from "@/components/PostalPlaceSelect";

export type PostalSource = "city" | "pincode" | "village";
export interface PostalAddress { state: string; city: string; district: string; pincode: string; village: string }

/** A PIN can cover many villages. Fill shared facts without choosing a village. */
export function postalAddressPatch(matches: PostalPlace[], source: PostalSource, current: PostalAddress): Partial<PostalAddress> {
  if (!matches.length) return {};
  const patch: Partial<PostalAddress> = {};
  for (const key of ["state", "district", "pincode"] as const) {
    const values = new Set(matches.map((match) => match[key]));
    if (values.size === 1) patch[key] = matches[0]![key];
  }
  if (source === "pincode" || !current.city.trim()) {
    const knownCities = matches.map((match) => match.city).filter((city): city is string => Boolean(city));
    const cities = new Set(knownCities.length ? knownCities : matches.map((match) => match.district));
    if (cities.size === 1) patch.city = [...cities][0]!;
  }
  if (matches.length === 1) patch.village = matches[0]!.locality;
  else if (source === "pincode") patch.village = "";
  return patch;
}
